<script setup lang="ts">
import findSm from "~/assets/icons/find/find-sm.svg"

const { searchButton } = useGlobals()
const { currentRootFolder, currentFilePreview } = useNavigation()
const { navPathViewTestId } = useTestId()
const { state: gestureState } = useGestures()
const { navPathId } = useGlobals()
const { openInstantMenu } = useInstantMenu()

const reversePath: ComputedRef<StaticFile[]> = computed(() => {
  if (isDefined(currentRootFolder.value?.path()))
    // @ts-expect-error -- we use core js to polyfill toReversed (see polyfill.ts)
    return [...currentRootFolder.value.path().toReversed(), currentRootFolder.value]
  else if (isDefined(currentFilePreview.value?.path()))
    // @ts-expect-error -- we use core js to polyfill toReversed (see polyfill.ts)
    return [...currentFilePreview.value.path().toReversed(), currentFilePreview.value]
  return []
})
</script>

<template>
  <nav-pill
    v-if="reversePath.length"
    :id="navPathId"
    class="path-pill-container"
    :data-testid="navPathViewTestId"
  >
    <template v-for="(file, i) in reversePath" :key="file.id">
      <nav-pill-button
        :data-path-file-id="file.id"
        class="path-pill-button"
        :selected="gestureState.pathFileDraggedOver?.id === file.id"
        :class="{
          bare: i !== 0,
          focused: i === reversePath.length - 1,
          default: i !== reversePath.length - 1,
        }"
      >
        <file-item
          :file
          class="file-item"
          :hide-thumbnail="i !== 0"
        />
      </nav-pill-button>
      <div v-if="i !== reversePath.length - 1" class="separator-container">
        <div class="separator" />
      </div>
    </template>
    <div class="search-pill-button">
      <nav-pill-button :class="[searchButton]" @click="openInstantMenu()">
        <findSm class="w-4.5 h-4.5" />
      </nav-pill-button>
    </div>
  </nav-pill>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.path-pill-container
  @apply overflow-hidden p-[#{$pill-m-button}]

.path-pill-button
  @apply flex-none pr-1.5 pl-0.5
  &.bare
    // NOTE: There was previously some styling here, but not anymore?
    @apply
  &.focused
    @apply text-[#{$pill-path-t-focused}]
  &.default
    @apply text-[#{$pill-path-t-default}]

.file-item
  @apply max-w-40 h-full gap-[#{$pill-gap-default}]

.separator-container
  @apply pill-item h-full flex-none px-0.5 pointer-events-none
.separator
  // FIXME: boltzmann variables
  @apply border-l-[#575B6C] h-full w-0 flex-none rotate-22 transform border-l

.search-pill-button
  @apply ml-1 h-full
</style>
